import React, { Component } from "react";
import { tableIcons } from "utils/MaterialTableHelper";
import colors from "styles/colors.module.scss";
import "./UserAdminContent.scss";
import { uepClient } from "uepClient";
import WithAlert from "hoc/WithAlert";
import { getUsername } from "utils/Common";
import TableToolbar from "./TableToolbar";
import AdminTableWrapper from "./AdminTableWrapper";
import { Modal } from "react-bootstrap";
import moment from "moment";
import AddCannedMessageForm from "components/AddCannedMessageForm/AddCannedMessageForm";
import CannedMessageSummaryService from "services/CannedMessageSummaryService";

const DATE_FORMAT = "DD MMM YYYY hh:mm a";
class CannedMessageContent extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      cannedMessageData: {
        totalPages: 0,
        currentPageSize: 0,
        cannedMessages: [],
      },
      selectedRows: [],
      searchText: "",
      showAddCannedMessageForm: false,
      isEditMode: false,
    };
    this.currentUser = getUsername();
  }

  componentDidMount() {
    this.fetchAllCannedMessages();
  }

  render() {
    const { isLoading, showAddCannedMessageForm } = this.state;
    const detailPanel = (rowData) => {
      return (
        <div className="detail-panel-ctr">
          <div className="detail-panel-field message">{rowData.body}</div>
          <div className="detail-panel-field category">{rowData.type}</div>
          <div className="detail-panel-field group">{rowData.group}</div>
          <div className="detail-panel-field last-updated">
            {rowData.updationDate
              ? moment(rowData.updationDate).format(DATE_FORMAT)
              : moment(rowData.createdDate).format(DATE_FORMAT)}
          </div>
        </div>
      );
    };

    return (
      <div className="admin-content">
        <div className="admin-list-table-container">
          <div className="table-wrapper">
            {this.renderTableToolbar()}
            <AdminTableWrapper
              icons={tableIcons}
              columns={this.getTableColumns()}
              data={this.getCannedMsgRecords()}
              isLoading={isLoading}
              onSelectionChange={this.onRowSelection}
              emptyMessage="No canned messages found."
              isRowSelected={this.isRowSelected}
              detailPanel={detailPanel}
              className="canned-msg-wrapper"
            />
          </div>
        </div>
        <Modal
          className="add-entity-modal"
          centered
          onHide={this.onAddCannedMessageFormClose}
          show={showAddCannedMessageForm}
        >
          <AddCannedMessageForm
            onFormClose={this.onAddCannedMessageFormClose}
            addNewCannedMsgToTable={this.addNewCannedMsgToTable}
            isEditMode={this.state.isEditMode}
            updateCannedMsgInTable={this.updateCannedMsgInTable}
            cannedMsgToUpdate={this.state.selectedRows[0]}
          />
        </Modal>
      </div>
    );
  }
  isRowSelected = (row) => {
    const { selectedRows } = this.state;
    return selectedRows.filter((r) => r.id === row.id).length > 0;
  };
  renderTableToolbar = () => {
    return (
      <TableToolbar
        searchValue={this.state.searchText}
        onSearchTextChange={this.onSearchTextChange}
        onAddButtonClick={this.onAddCannedMessageClick}
        isEditEnabled={this.state.selectedRows.length === 1}
        isDeleteEnabled={this.state.selectedRows.length > 0}
        onDeleteClick={this.onDeleteClick}
        onEditClick={this.onEditClick}
        showBUTabs={true}
        title="Manage Canned Message"
      />
    );
  };

  onDeleteClick = () => {
    const { selectedRows } = this.state;
    const selectedCannedMsgIds = selectedRows.map((r) => r.id);
    this.deleteCannedMsgs(selectedCannedMsgIds);
  };

  deleteCannedMsgs = (selectedCannedMsgIds) => {
    this.setState({
      isLoading: true,
    });
    const cannedMsgIdsQueryParams = selectedCannedMsgIds.join(",");
    uepClient()
      .delete(`/canned-message?ids=${cannedMsgIdsQueryParams}`)
      .then((res) => {
        if (res.status === 200) {
          this.removeDeletedCannedMsgsFromTable(selectedCannedMsgIds);
          console.info(
            `Admin ${this.currentUser} deleted canned messages with id's: ${selectedCannedMsgIds}`
          );
          this.props.showAlert({
            variant: "success",
            content: (
              <span>
                <b>Succesfully</b> deleted the selected canned message(s).
              </span>
            ),
          });
        }
      })
      .catch((err) => {
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> {err.message}
            </span>
          ),
        });
        console.error(
          `Error occurred while Admin-${
            this.currentUser
          } trying to delete canned messages with id's: ${selectedCannedMsgIds.join(
            ","
          )}, ${err}`
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  notifyCannedMessageSummary = () => {
    CannedMessageSummaryService.fetchCannedMessageCounts();
  };

  addNewCannedMsgToTable = (newCannedMsg) => {
    const { cannedMessageData } = this.state;
    const existingCannedMsgs = [].concat(cannedMessageData.cannedMessages);

    const updatedCannedMessages = existingCannedMsgs.concat(newCannedMsg);
    this.setState({
      cannedMessageData: {
        ...cannedMessageData,
        cannedMessages: updatedCannedMessages,
      },
      selectedRows: [],
    });

    this.notifyCannedMessageSummary();
  };

  updateCannedMsgInTable = (updatedCannedMsg) => {
    const { cannedMessageData } = this.state;
    const existingCannedMsgs = [].concat(cannedMessageData.cannedMessages);
    const indexOfExistingCannedMsgToUpdate = existingCannedMsgs.findIndex(
      (cannedMsg) => cannedMsg.id === updatedCannedMsg.id
    );
    if (indexOfExistingCannedMsgToUpdate !== -1) {
      existingCannedMsgs.splice(
        indexOfExistingCannedMsgToUpdate,
        1,
        updatedCannedMsg
      );
    }
    this.setState({
      cannedMessageData: {
        ...cannedMessageData,
        cannedMessages: existingCannedMsgs,
      },
      selectedRows: [],
    });

    this.notifyCannedMessageSummary();
  };

  removeDeletedCannedMsgsFromTable = (deletedCannedMsgIds) => {
    const { cannedMessageData } = this.state;

    const updatedCannedMsgData = cannedMessageData.cannedMessages.filter(
      (cannedMsg) => !deletedCannedMsgIds.includes(cannedMsg.id)
    );

    this.setState({
      cannedMessageData: {
        ...cannedMessageData,
        cannedMessages: updatedCannedMsgData,
      },
      selectedRows: [],
    });

    this.notifyCannedMessageSummary();
  };

  onEditClick = () => {
    this.setState({
      showAddCannedMessageForm: true,
      isEditMode: true,
    });
  };

  onAddCannedMessageClick = () => {
    this.setState({
      isEditMode: false,
      showAddCannedMessageForm: true,
    });
  };

  onAddCannedMessageFormClose = () => {
    this.setState({
      showAddCannedMessageForm: false,
    });
  };

  onSearchTextChange = (searchText) => {
    this.setState({
      searchText,
    });
  };

  fetchAllCannedMessages = () => {
    uepClient()
      .get("/canned-message/all")
      .then((res) => {
        const transformedMsgs = res.data.map((msg) => {
          return {
            ...msg,
            createdDate: moment(msg.createdDate).toISOString(),
            updationDate: msg.updationDate
              ? moment(msg.updationDate).toISOString()
              : msg.updationDate,
          };
        });
        this.setState({
          cannedMessageData: {
            cannedMessages: transformedMsgs,
          },
          isLoading: false,
        });
      })
      .catch((err) => {
        console.error(`Failed to fetch list of canned messages : ${err}`);
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> Failed to fetch list of canned messages.
            </span>
          ),
        });
      });
  };
  getCannedMsgRecords = () => {
    const { cannedMessageData, searchText } = this.state;
    return searchText.trim().length
      ? cannedMessageData.cannedMessages.filter((r) => this.validateSearch(r))
      : cannedMessageData.cannedMessages;
  };
  validateSearch = (row) => {
    const { searchText } = this.state;
    const searchLc = searchText.toLowerCase();
    const messageValidator = row.body.toLowerCase().includes(searchLc);
    const groupValidator = row.group.toLowerCase().includes(searchLc);
    const categoryValidator = row.type.toLowerCase().includes(searchLc);
    const lastUpdatedValidator =
      moment(row.updationDate)
        .format(DATE_FORMAT)
        .toString()
        .toLowerCase()
        .includes(searchLc) ||
      moment(row.createdDate)
        .format(DATE_FORMAT)
        .toString()
        .toLowerCase()
        .includes(searchLc);
    return (
      messageValidator ||
      categoryValidator ||
      groupValidator ||
      lastUpdatedValidator
    );
  };
  getTableColumns = () => {
    const tableColumns = [
      {
        title: "Canned Message",
        field: "cannedMessage",
        render: (rowData) => {
          return rowData.body.length > 30
            ? rowData.body.slice(0, 30) + "..."
            : rowData.body;
        },
        filtering: false,
        sorting: false,
      },
      {
        title: "Category",
        field: "category",
        filtering: false,
        sorting: false,
        render: (rowData) => {
          return rowData.type;
        },
      },
      {
        title: "Group",
        field: "group",
        render: (rowData) => {
          return rowData.group;
        },
      },
      {
        title: "Last Updated",
        field: "lastUpdated",
        defaultSort: "desc",
        customSort: (a, b) => {
          const dateTimeA = a.updationDate ? a.updationDate : a.createdDate;
          const dateTimeB = b.updationDate ? b.updationDate : b.createdDate;
          return moment(dateTimeA).isAfter(moment(dateTimeB)) ? 1 : -1;
        },
        render: (rowData) => {
          const dateTime = rowData.updationDate
            ? rowData.updationDate
            : rowData.createdDate;
          return moment(dateTime).format(DATE_FORMAT);
        },
      },
    ];

    const tableColumnsWithStyle = tableColumns.map((tc) => ({
      ...tc,
      cellStyle: {
        border: 0,
        color: colors.darkGrey,
        fontWeight: "normal",
      },
      headerStyle: {
        border: 0,
        color: colors.darkGrey,
        fontWeight: "300",
        fontSize: "1em",
      },
    }));
    return tableColumnsWithStyle;
  };

  onRowSelection = (rows) => {
    const selectedIds = rows.map((r) => r.id);
    const selectedIdsSet = new Set(selectedIds);
    this.setState({
      selectedRows: rows,
      selectedIds: selectedIdsSet,
    });
  };
}

const CannedMessageContentWithAlert = WithAlert(CannedMessageContent);

export default CannedMessageContentWithAlert;
